import { render, staticRenderFns } from "./TrainingModal.vue?vue&type=template&id=d89562d2&"
import script from "./TrainingModal.vue?vue&type=script&lang=js&"
export * from "./TrainingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports